import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from 'react';
import api, { TOKEN_KEY } from '../api/client';
const Ctx = createContext(null);
export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (!localStorage.getItem(TOKEN_KEY)) { setLoading(false); return; }
    api.get('/auth/me').then(r => setUser(r.data)).catch(() => localStorage.removeItem(TOKEN_KEY)).finally(() => setLoading(false));
  }, []);
  const login = useCallback(async (u, p) => {
    const r = await api.post('/auth/login', { username: u, password: p });
    localStorage.setItem(TOKEN_KEY, r.data.token); setUser(r.data.user); return r.data.user;
  }, []);
  const logout = useCallback(() => { localStorage.removeItem(TOKEN_KEY); setUser(null); }, []);
  const can = useCallback(c => !!user?.permissions?.includes(c), [user]);
  const value = useMemo(() => ({ user, loading, login, logout, can }), [user, loading, login, logout, can]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}
export const useAuth = () => useContext(Ctx);
